module.exports = __webpack_public_path__ + "static/media/nuvemshop15.64887c5c.png";